<template>
  <header class="site-header">
    <div class="scroll-progress" aria-hidden="true">
      <span class="scroll-progress-bar"></span>
    </div>
    <CollapsibleRoot
      as="nav"
      :open="isDesktop || isMenuOpen"
      aria-label="Main navigation"
      class="site-nav"
      @update:open="handleOpenChange"
    >
      <router-link to="/" class="logo-mark" @click="closeMenu">
        <img
          src="@/assets/Zearloops Logo Name.png"
          alt="Zearloops"
          class="logo-image"
        >
      </router-link>

      <CollapsibleTrigger
        class="nav-toggle"
        type="button"
        :aria-label="isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </CollapsibleTrigger>

      <CollapsibleContent class="nav-content">
        <ul class="nav-links">
          <li><router-link :to="{ path: '/', hash: '#home' }" :class="{ 'is-selected': activeSection === 'home' }" @click="closeMenu">Home</router-link></li>
          <li><router-link :to="{ path: '/', hash: '#games' }" :class="{ 'is-selected': activeSection === 'games' }" @click="closeMenu">Games</router-link></li>
          <li><router-link :to="{ path: '/', hash: '#about' }" :class="{ 'is-selected': activeSection === 'about' }" @click="closeMenu">About</router-link></li>
          <li><router-link :to="{ path: '/', hash: '#contact' }" :class="{ 'is-selected': activeSection === 'contact' }" @click="closeMenu">Contact</router-link></li>
        </ul>
      </CollapsibleContent>
    </CollapsibleRoot>
  </header>
</template>

<script>
import { CollapsibleContent, CollapsibleRoot, CollapsibleTrigger } from 'reka-ui';

export default {
  name: 'AppNavigation',
  components: {
    CollapsibleContent,
    CollapsibleRoot,
    CollapsibleTrigger
  },
  data() {
    return {
      isMenuOpen: false,
      isDesktop: window.innerWidth > 760,
      activeSection: this.$route.path === '/' ? 'home' : null,
    };
  },
  watch: {
    '$route.path'() {
      this.$nextTick(this.updateActiveSection);
    },
    '$route.hash'() {
      this.$nextTick(this.updateActiveSection);
    }
  },
  methods: {
    handleOpenChange(open) {
      this.isMenuOpen = open;
    },
    closeMenu(event) {
      if (!this.isMenuOpen) {
        return;
      }

      const navToggle = event.currentTarget
        .closest('.site-nav')
        ?.querySelector('.nav-toggle');

      this.isMenuOpen = false;

      this.$nextTick(() => {
        navToggle?.focus({ preventScroll: true });
      });
    },
    handleResize() {
      this.isDesktop = window.innerWidth > 760;
      if (this.isDesktop) {
        this.isMenuOpen = false;
      }
      this.$nextTick(this.updateActiveSection);
    },
    updateActiveSection() {
      if (this.$route.path !== '/') {
        this.activeSection = null;
        return;
      }

      const sections = ['home', 'games', 'about', 'contact']
        .map(id => document.getElementById(id))
        .filter(Boolean);

      if (!sections.length) {
        this.activeSection = null;
        return;
      }

      const scrollMarginTop = Number.parseFloat(
        window.getComputedStyle(sections[0]).scrollMarginTop
      ) || 0;
      const activeLine = Math.max(
        this.$el.getBoundingClientRect().height,
        scrollMarginTop
      ) + Math.round(window.innerHeight * 0.2);
      const currentSection = sections.reduce((active, section) => (
        section.getBoundingClientRect().top <= activeLine ? section.id : active
      ), sections[0].id);

      if (currentSection !== this.activeSection) {
        this.activeSection = currentSection;
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.updateActiveSection, { passive: true });
    this.$nextTick(this.updateActiveSection);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.updateActiveSection);
  }
};
</script>
